import axiosInstance, { endpoints } from 'src/utils/axios';

import type { EmailHostSetting, PassRuleSetting, WebsiteSetting } from './types';

const normalizeNullableText = <T extends Record<string, any>>(data: T): T =>
  Object.fromEntries(Object.entries(data).map(([key, value]) => [key, value ?? ''])) as T;

export async function getPassRuleSetting(): Promise<PassRuleSetting> {
  const response = await axiosInstance.get(endpoints.settings.passRule);
  return normalizeNullableText(response.data);
}

export async function updatePassRuleSetting(payload: PassRuleSetting): Promise<PassRuleSetting> {
  const response = await axiosInstance.put(endpoints.settings.passRule, payload);
  return normalizeNullableText(response.data);
}

export async function getEmailHostSetting(): Promise<EmailHostSetting> {
  const response = await axiosInstance.get(endpoints.settings.emailHost);
  return normalizeNullableText(response.data);
}

export async function updateEmailHostSetting(
  payload: Partial<EmailHostSetting>
): Promise<EmailHostSetting> {
  const response = await axiosInstance.put(endpoints.settings.emailHost, payload);
  return normalizeNullableText(response.data);
}

export async function sendTestEmail(testEmail: string) {
  const response = await axiosInstance.post(endpoints.settings.testEmailHost, { testEmail });
  return response.data;
}

export async function getWebsiteSetting(): Promise<WebsiteSetting> {
  const response = await axiosInstance.get(endpoints.settings.website);
  return normalizeNullableText(response.data);
}

export async function updateWebsiteSetting(payload: WebsiteSetting): Promise<WebsiteSetting> {
  const response = await axiosInstance.put(endpoints.settings.website, payload);
  return normalizeNullableText(response.data);
}

export async function getPublicWebsiteSetting(): Promise<WebsiteSetting> {
  const response = await axiosInstance.get(endpoints.settings.websitePublic);
  return normalizeNullableText(response.data);
}

export async function uploadSettingImage(file: File): Promise<string> {
  const formData = new FormData();
  formData.append('file', file);

  const response = await axiosInstance.post(`${endpoints.upload}?folderName=website`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  const path = response.data?.path;
  if (!path) return '';

  return String(path).startsWith('/') ? path : `/${path}`;
}
